<template>
  <el-form ref="form" :model="user" :rules="rules" label-width="180px">
    <el-form-item :label="this.$t('userinfo.resetpwd.oldpwd')" prop="oldPassword">
      <el-input v-model="user.oldPassword" :placeholder="this.$t('userinfo.resetpwd.oldpwdhint')" type="password" show-password/>
    </el-form-item>
    <el-form-item :label="this.$t('userinfo.resetpwd.newpwd')" prop="newPassword">
      <el-input v-model="user.newPassword" :placeholder="this.$t('userinfo.resetpwd.newpwdhint')" type="password" show-password/>
    </el-form-item>
    <el-form-item :label="this.$t('userinfo.resetpwd.confirmpwd')" prop="confirmPassword">
      <el-input v-model="user.confirmPassword" :placeholder="this.$t('userinfo.resetpwd.confirmpwdhint')" type="password" show-password/>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" size="mini" @click="submit">{{$t('userinfo.resetpwd.submit')}}</el-button>
      <el-button type="danger" size="mini" @click="close">{{$t('userinfo.resetpwd.close')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>

export default {
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.user.newPassword !== value) {
        callback(new Error("this.$t('userinfo.resetpwd.error1')"));
      } else {
        callback();
      }
    };
    return {
      user: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      },
      // 表单校验
      rules: {
        oldPassword: [
          { required: true, message: this.$t('notification.resetpwdmessage1'), trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: this.$t('notification.resetpwdmessage2'), trigger: "blur" },
          { min: 3, max: 20, message: this.$t('notification.resetpwdmessage3'), trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: this.$t('notification.resetpwdmessage4'), trigger: "blur" },
          { required: true, validator: equalToPassword, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    submit() {
      	let data={
      		oldPwd: this.user.oldPassword,
			newPwd: this.user.newPassword
      	}
      	this.postRequest('/tpa-api/admin/updateAdminPassword', data).then(resp=>{
      		if(resp.code == 200){
      			this.getRequest("/tpa-api/admin/logout");
      			// 删除用户数据
      			window.localStorage.removeItem("user");
      			window.localStorage.removeItem("token");
      			// 清空菜单
      			this.$store.commit('initRoutes', []);
      			// 跳转登录页
      			this.$router.replace("/");
      		}
      		this.cardialogFormVisible = false;
      	})
    },
    close() {
     this.$router.replace('/home');
    }
  }
};
</script>
